<template>
  <div class="processing-progress">
    {{ message }}
  </div>
</template>

<script>
const FIRST_MESSAGE = "Uploading file";

export default {
  name: "ProcessingProgress",
  props: {
    message: {
      type: String,
      default: FIRST_MESSAGE
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.processing-progress {
  line-height: 100%;
  margin: 6px 0;

  &::after {
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    animation: ellipsis steps(4, end) 2s infinite;
    content: "...";
    width: 0;
  }

  @keyframes ellipsis {
    25% {
      width: 10px;
    }
    50% {
      width: 20px;
    }
    75% {
      width: 30px;
    }
    100% {
      width: 40px;
    }
  }
}
</style>
